import { LISCaseListPatient, LISPatient, Patient } from "pwapi";

export const truncatePatientName = (
  patient?: Patient | LISPatient | LISCaseListPatient,
  maxLength = 14
) => {
  const firstName = patient?.first_name || "";
  const lastName = patient?.last_name || "";

  /*
  Format the patient's name to fit onto the cassette. The cassette can
  hold up to 14 characters. We keep up to four letters of the first name
  and use as much of the last name as possible to fill 14 characters.

  Possible formats for samples:
  1) First VeryLongLast  ->  VeryLong, Firs
  2) F VeryLongLast      ->  VeryLongLas, F
  3) First Last          ->  Last, First
  4) Tyler               ->  Tyler
  */
  const full = [lastName, firstName].filter((s) => !!s).join(", ");
  if (full.length <= maxLength) return full;

  const shortFirstName = firstName.slice(0, Math.max(4, maxLength - 10));
  const joinStrLength = firstName && lastName ? 2 : 0; // Length of ", "
  const shortLastName = lastName.slice(
    0,
    maxLength - shortFirstName.length - joinStrLength
  );
  return [shortLastName, shortFirstName].filter((s) => !!s).join(", ");
};
